<template>
    <table class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
        <thead>
            <tr>
                <th v-if="!this.hide.includes('name')">Name</th>
                <th v-if="!this.hide.includes('customer')">Customer</th>
                <th v-if="!this.hide.includes('reference')">Reference</th>
                <th v-if="!this.hide.includes('contact')">Contact</th>
                <th v-if="!this.hide.includes('vehicleRate')">Vehicle Rate</th>
                <th v-if="!this.hide.includes('actions')">Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
import { buildColumns } from "@/helpers/build-columns";

export default {
    props: {
        ajaxUrl: String,
        hide: {
            type: Array,
            default: () => [],
            required: false
        },
    },

    data() {
        return {
            columnDefinitions: {
                name: {
                    data: 'name',
                },
                customer: {
                    name: 'customer.name',
                    searchable: false,
                    orderable: false,
                    render: (data, type, row) => row.computed_customer,
                },
                reference: {
                    data: 'account_code',
                },
                contact: {
                    data: 'contact_name',
                },
                vehicleRate: {
                    data: 'computed_vehicle_rate',
                    searchable: false,
                    orderable: false,
                },
                actions: {
                    data: 'actions',
                    searchable: false,
                    orderable: false,
                    width: '200px',
                },
            }
        }
    },

    mounted() {
        window.jQuery(this.$el).dataTable({
            processing: true,
            serverSide: true,
            pageLength: 25,
            lengthMenu: [25, 50, 100],
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[0, 'asc']],
            columns: buildColumns(this.columnDefinitions, this.hide),
        });
    },
};
</script>
